// ZOD
import * as z from 'zod';
import { ClientType, ClientZod, ClientSlugType, ClientSlugZod } from '@/views/Client/ClientType';

// Strapi
import { blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getClient = async (slug: string): Promise<ClientType> =>
  fetchStrapiContentWithBlocks(
    `/api/clients/${slug}`,
    ClientZod,
    {
      title: {
        populate: '*',
      },
      paragraph: {
        populate: '*',
      },
      gradient: {
        populate: '*',
      },
      tags: {
        populate: '*',
      },
      blocks,
      seo,
    },
    'Client Page',
  );

export const getClients = async (): Promise<Array<ClientSlugType>> => {
  const pageSize = 10;
  const response = await client.get('/api/clients', {
    params: {
      fields: ['slug'],
      populate: {
        seo,
      },
      pagination: {
        page: 1,
        pageSize,
      },
    },
  });

  const totalPages = response.data?.meta?.pagination.pageCount || 1;
  const allData = [...(response.data?.data ?? [])];

  try {
    if (totalPages > 1) {
      const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) =>
        client.get('/api/clients', {
          params: {
            fields: ['slug'],
            populate: {
              seo,
            },
            pagination: { page: i + 2, pageSize },
          },
        }),
      );
      const results = await Promise.all(pagePromises);
      results.forEach((r) => allData.push(...(r.data?.data || [])));
    }

    return z.array(ClientSlugZod).parseAsync(allData);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Clients structure:\n${formatZodError(error, allData)}`);
    }
    throw error;
  }
};
